import React, { useEffect } from 'react';
import { ParkingWizard } from 'Views/Components/_HumanWritten/ParkingWizard/ParkingWizard';
import { useParkingWizardStore } from 'Stores/ParkingWizardStore';

export default function ParkingPage() {
	const reset = useParkingWizardStore(state => state.reset);

	useEffect(() => {
		document.title = 'Parking';
		return () => {
			reset();
		};
	}, [reset]);

	return (
		<div className="body-content">
			<ParkingWizard />
		</div>
	);
}
